import React from 'react';
import _ from 'lodash';
import formatBytes from '../../helpers/format-bytes';

export default function DownloadableItem({ data, type }) {
  const title = _.get(data, 'content.title', '');
  const text = _.get(data, 'content.text', '');
  const file = _.get(data, 'content.file', {});
  const fileSize = _.get(data, 'content.fileSize', {});

  return (
    <a 
    href={file.url} 
    download 
    target="_blank" 
    rel="noreferrer" 
    className={`cta-${type} flex flex-row gap-3 md:gap-[25px]`}>
        <span>
          <svg
            className="h-6 w-auto lg:h-10 min-w-max"
            xmlns="http://www.w3.org/2000/svg"
            width="42"
            height="42"
            viewBox="0 0 42 42"
            fill="none">
            <path
              d="M21 23.9622L17.0489 20.0133M21 23.9622L24.9511 20.0133M21 23.9622V12.1111M29.8889
            25.9378C29.8889 26.9857 29.4726 27.9907 28.7316 28.7316C27.9907 29.4726 26.9857 29.8889
            25.9378 29.8889H16.0622C15.0143 29.8889 14.0093 29.4726 13.2684 28.7316C12.5274 27.9907
            12.1111 26.9857 12.1111 25.9378M41 21C41 32.0457 32.0457 41 21 41C9.95431 41 1 32.0457 1
            21C1 9.95431 9.95431 1 21 1C32.0457 1 41 9.95431 41 21Z"
              stroke="#CE445B"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>

        <div className="flex flex-col">
          <h2 className="text-clamp12to18 leading-1.5 !font-DINRegular text-[#000] mb-0">
            {title}
          </h2>
          <span
            className="text-clamp12to15 !font-DINRegular text-[#4A4A4A] lg:mb-[15px]
          md:mt-[10px] mb-2 md:mb-0">
            {`${_.last(_.split(file.url, '.')).toUpperCase()} • ${fileSize || '0 Bytes'}`}
          </span>
          <p className="text-clamp12to16 leading-1.5 m-0 !font-DINRegular text-[#4A4A4A]">{text}</p>
        </div>
      </a>
  );
}
